// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { SwitchTokens } from './type';

const switchTokens: SwitchTokens = {
  switchFontSize: '14/regular',
  switchFontColor: 'Neutral-text-1',
  switchPaddingX: 'Padding-2',
  switchPaddingY: 'Padding-2',
  switchCircleSize: 'Size-9',
  switchCircleFill: 'Neutral-text-1',
  switchCircleShadow: 'Shadow-3',
  switchWidth: 'Size-21',
  switchTextPaddingX: 'Padding-4',
  switchSmallFontSize: '12/regular',
  switchSmallPaddingX: 'Padding-2',
  switchSmallPaddingY: 'Padding-2',
  switchSmallCircleSize: 'Size-6',
  switchSmallWidth: 'Size-14',
  switchLargeFontSize: 'regular/16',
  switchLargePaddingX: 'Padding-2',
  switchLargePaddingY: 'Padding-2',
  switchLargeCircleSize: 'Size-12',
  switchLargeWidth: 'Size-27',
  switchBackgroundColor: 'Neutral-fill-4',
  switchDisabledBackgroundColor: 'Neutral-fill-2',
  switchDisabledCircleFill: 'Neutral-text-2',
  switchDisabledFontColor: 'Neutral-text-2',
  switchLoadingBackgroundColor: 'Neutral-fill-2',
  switchLoadingCircleFill: 'Neutral-text-2',
  switchLoadingFontColor: 'Neutral-text-2',
  switchCheckedBackgroundColor: 'Brand-6',
  switchCheckedFontColor: 'Neutral-text-1',
  switchCheckedDisabledBackgroundColor: 'Brand-3',
  switchCheckedDisabledFontColor: 'Neutral-text-1',
  switchCheckedLoadingBackgroundColor: 'Brand-3',
  switchCheckedLoadingFontColor: 'Neutral-text-1',
};

export default switchTokens;
